import { engagements } from '../content/services'

export const navigationData = {
  products: {
    title: 'Products',
    href: '/products',
    description: 'The Graffiti™ OS framework, its hardware, and the 23Controls™ governance underneath it',
    categories: [
      {
        name: 'Graffiti™ Scrambler',
        href: '/products/home',
        items: [
          { name: 'Device Details', href: '/products/devices/graffiti-scrambler', description: 'Specs, pricing, and what ships in the box' },
          { name: 'Voice Demo', href: '/products/home/demo', description: 'Try the AI chat interface' },
          { name: 'Case Marketplace', href: '/products/home/marketplace', description: 'Extensions & add-ons' },
        ]
      },
      {
        name: '23Controls™ Governance',
        href: '/products/governance',
        items: [
          { name: '23Controls™ & Graffiti™ OS', href: '/products/governance', description: 'Governed AI, from the first action' },
          { name: 'RAG & Multi-Model Workflows', href: '/products/enterprise/rag-workflows', description: 'Governed retrieval for your own data' },
        ]
      },
      {
        name: 'Build with Graffiti™',
        href: '/products/developer',
        items: [
          { name: 'How It Works', href: '/products/developer', description: 'The architecture, in plain terms, for builders and integrators' },
          { name: 'Documentation', href: '/training/resources/docs', description: 'Technical guides' },
        ]
      }
    ]
  },
  aiOps: {
    title: 'AI Operations',
    href: '/ai-operations',
    description: 'The AI Operations Suite — Conductor workflows for local, governed RAG and DAG operations',
    categories: [
      {
        name: 'The Suite',
        href: '/ai-operations',
        items: [
          { name: 'Suite Overview', href: '/ai-operations', description: 'Every space, in the order you use them' },
          { name: 'Guided Demo', href: '/demo', description: 'Walk through the suite, scene by scene' },
        ]
      },
      {
        name: 'Capabilities',
        href: '/ai-operations/prompt-shaping',
        items: [
          { name: 'Prompt Shaping', href: '/ai-operations/prompt-shaping', description: 'Turn a loose ask into a routed request' },
          { name: 'DocFlow', href: '/ai-operations/docflow', description: 'Read, question, and treat documents' },
          { name: 'Conductor Canvas', href: '/ai-operations/conductor-canvas', description: 'Draw a workflow, deploy a DAG' },
        ]
      },
      {
        name: 'Operate',
        href: '/ai-operations/workflow-catalog',
        items: [
          { name: 'Workflow Catalog & Scheduler', href: '/ai-operations/workflow-catalog', description: 'Every workflow, every run' },
          { name: 'Attribution', href: '/ai-operations/attribution', description: 'Explainable touchpoint credit (early access)' },
          { name: 'Governed by 23Controls™', href: '/ai-operations/governed', description: 'Identity, policy, audit — and how to subscribe' },
        ]
      }
    ]
  },
  services: {
    title: 'Services',
    href: '/services',
    description: 'Training, adoption, and managed operations for Graffiti™ and 23Controls™',
    categories: [
      {
        name: 'Engagements',
        href: '/services',
        items: engagements.map((e) => ({ name: e.name, href: `/services/${e.id}`, description: e.tagline })),
      },
      {
        name: 'Get Started',
        href: '/support/contact/sales',
        items: [
          { name: 'Talk to Our Team', href: '/support/contact/sales', description: 'Scope an engagement with a real person' },
          { name: 'AI Operations Suite', href: '/ai-operations', description: 'What you would be adopting' },
        ]
      },
    ]
  },
  learn: {
    title: 'Learn',
    href: '/philosophy',
    description: 'Understand the technology, and the thinking behind it',
    categories: [
      {
        name: 'About the Technology',
        href: '/philosophy',
        items: [
          { name: 'Our Philosophy', href: '/philosophy', description: 'Why we built Graffiti™ the way we did' },
          { name: 'How Governance Works', href: '/products/governance', description: '23Controls™, explained' },
        ]
      },
      {
        name: 'Resources',
        href: '/training/resources',
        items: [
          { name: 'Documentation', href: '/training/resources/docs', description: 'Technical guides' },
          { name: 'Education & Training', href: '/services/training', description: 'Onboarding support and insight from our team, available now' },
          { name: 'Publications', href: '/support/contact', description: "Not yet public — reach out if you'd like to know more" },
        ]
      }
    ]
  },
  support: {
    title: 'Support',
    href: '/support',
    description: 'We\'re here to help',
    categories: [
      {
        name: 'Help Center',
        href: '/support/help',
        items: [
          { name: 'FAQs', href: '/support/help/faq', description: 'Common questions' },
          { name: 'Troubleshooting', href: '/support/help/troubleshoot', description: 'Problem solving' },
          { name: 'Status Page', href: '/support/help/status', description: 'System health' },
        ]
      },
      {
        name: 'Contact',
        href: '/support/contact',
        items: [
          { name: 'Technical Support', href: '/support/contact/technical', description: '24/7 expert help' },
          { name: 'Sales Inquiries', href: '/support/contact/sales', description: 'Talk to our team' },
          { name: 'Partnerships', href: '/support/contact/partnerships', description: 'Business development' },
        ]
      },
      {
        name: 'Your Account',
        href: '/support/account',
        items: [
          { name: 'Orders & Billing', href: '/support/account/billing', description: 'Invoices, payments, and shipment status' },
          { name: 'Subscription', href: '/support/account/subscription', description: 'Plan management' },
          { name: 'Security', href: '/support/account/security', description: 'Access & permissions' },
        ]
      }
    ]
  },
  corporate: {
    title: 'Company',
    href: '/corporate',
    description: 'About Mimeograph Holdings, LLC and SynthetIQ Signals, Inc.',
    categories: [
      {
        name: 'Company',
        href: '/corporate/company',
        items: [
          { name: 'About Us', href: '/corporate/company/about', description: 'Our story & mission' },
          { name: 'Our Philosophy', href: '/philosophy', description: 'The Graffiti™ vision' },
          { name: 'Leadership', href: '/corporate/company/leadership', description: 'Meet the team' },
          { name: 'Careers', href: '/corporate/company/careers', description: 'Join our mission' },
        ]
      },
      {
        name: 'News',
        href: '/corporate/news',
        items: [
          { name: 'Press Releases', href: '/corporate/news/press', description: 'Official announcements' },
          { name: 'Blog', href: '/corporate/news/blog', description: 'Insights & updates' },
          { name: 'Events', href: '/corporate/news/events', description: 'Conferences & webinars' },
        ]
      },
      {
        name: 'Legal',
        href: '/corporate/legal',
        items: [
          { name: 'Terms of Service', href: '/corporate/legal/terms', description: 'Usage agreement' },
          { name: 'Privacy Policy', href: '/corporate/legal/privacy', description: 'Data protection' },
          { name: 'Cookie Policy', href: '/corporate/legal/cookies', description: 'Cookies & tracking' },
          { name: 'Compliance', href: '/corporate/legal/compliance', description: 'Regulatory standards' },
        ]
      }
    ]
  }
}

export const quickLinks = [
  { name: 'Documentation', href: '/training/resources/docs' },
  { name: 'Pricing', href: '/products' },
  { name: 'Contact', href: '/support/contact' },
]